import { getBoxValue } from '../../Components/utils/functions';
import { getBorderCSS, getTypoCSS } from '../../Components/utils/getCSS';

const Style = ({ attributes, clientId }) => {
	const { columnGap, rowGap, img, titleTypo, titleColor, descTypo, descColor, info, player, boxPadding, boxBorder } = attributes;
	const mainEle = `#ytvgbYouTubeVideoGallery-${clientId}`;
	const galleryDirectoryEle = `${mainEle} .videoGallery`;
	const playlistDetailsEle = `${mainEle} .playlist`;

	return <style dangerouslySetInnerHTML={{
		__html: `

		${getTypoCSS('', titleTypo)?.googleFontLink}
		${getTypoCSS('', descTypo)?.googleFontLink}
		${getTypoCSS(`${galleryDirectoryEle} .singleItem .videosTitle h1 a`, titleTypo)?.styles}
		${getTypoCSS(`${galleryDirectoryEle} .singleItem .videosDes p`, descTypo)?.styles}

		${galleryDirectoryEle} {
			grid-gap: ${rowGap} ${columnGap};
		}

		${galleryDirectoryEle} .singleItem {
			padding:${getBoxValue(boxPadding)};
			${getBorderCSS(boxBorder)};
		}

		${galleryDirectoryEle} .singleItem .videosTitle h1 a {
			color:${titleColor};
		}

		${galleryDirectoryEle} .singleItem .videosDes p {
			color:${descColor};
		}

		${galleryDirectoryEle} .singleItem .videosInfo span {
			font-size:${info?.numberSize}px;
			color:${info?.numberColor};
		}

		${galleryDirectoryEle} .singleItem .iframeEle iframe,
		${galleryDirectoryEle} .playlistContainer .playlist .singleItem .img img  {
			border-radius:${img?.bRadius};
		}

		${galleryDirectoryEle} .playlistContainer .playlist .singleItem .img::after {
			border-radius:${img?.bRadius};
		}

		${playlistDetailsEle} .playlistContainer .playlist {
			max-height: ${player?.height}px;
		}
 	 
	`}} />;
}
export default Style;